import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHorizontalRule = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 12.75C2 12.3358 2.33579 12 2.75 12H21.25C21.6642 12 22 12.3358 22 12.75C22 13.1642 21.6642 13.5 21.25 13.5H2.75C2.33579 13.5 2 13.1642 2 12.75Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgHorizontalRule;
